import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";

export default function NotReadyForInvoiceModal({ open, setOpen, items }) {
  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setOpen(false);
      }}
    >
      <Modal.Content>
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">
            Cannot Approve For Invoicing
          </Title>
          <Columns isMultiline>
            <Column>
              <p className="is-centered">
                The following items are not ready for invoicing:
              </p>
              <ul>
                {items.map(item => (
                  <li>{item.description}</li>
                ))}
              </ul>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  setOpen(false);
                }}
                isFullWidth
              >
                Close
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
